























































import { Component, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { ScheduleDateFilter } from "@/store/modules/types";
import DatePicker from "vuejs-datepicker";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class ReferenceDateFilter extends Vue {
  id = "appt-schedule-date-popover";
  target = "appt-schedule-date-target";
  filter = this.defaultFilter();
  defaultFilter(): ScheduleDateFilter {
    return {
      from: null,
      to: null,
    };
  }
  search() {
    const filter = { ...this.filter };
    this.$store.commit("schedule/SET_REPORT_APPT_DATE_FILTER", filter);
    this.close();
  }
  clear() {
    this.filter = this.defaultFilter();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { referenceDate } = this.$store.state.schedule.filter;
    this.filter = JSON.parse(JSON.stringify(referenceDate));
  }
}
